import { render, staticRenderFns } from "./contactFooter.vue?vue&type=template&id=1b81b790&scoped=true&lang=pug&"
import script from "./contactFooter.vue?vue&type=script&lang=js&"
export * from "./contactFooter.vue?vue&type=script&lang=js&"
import style0 from "./contactFooter.vue?vue&type=style&index=0&id=1b81b790&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b81b790",
  null
  
)

export default component.exports